<template>
    <!-- 报警参数 -->
    <div>
        <el-form label-width="150px" label-position="left">
            <el-row :gutter="50">
                <el-col :span="24">
                    <el-form-item :label="$t('integration.alarm_switch')">
                        <span>{{ params.alaram_switch ? $t('integration.open') : $t('integration.close') }}</span>
                    </el-form-item>
                </el-col>
                <template v-if="params.alaram_switch">
                    <el-col :span="8">
                        <el-form-item :label="$t('integration.alarm_volume_')">
                            <span>{{ params.alarm_voice_size }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.alarm_time_(seconds)')">
                            <span>{{ params.alarm_time_size }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.alarm_interval_(seconds)')">
                            <span>{{ params.alarm_interval_time }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.number_of_alarms')">
                            <span>{{ params.alarm_size }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.number_of_labels_per_page')">
                            <span>{{ params.tag_size }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.mqtt_address')">
                            <span>{{ params.mqtt_broker_address }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.mqtt_port')">
                            <span>{{ params.mqtt_broker_port }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.mqtt_connection_timeout')">
                            <span>{{ params.mqtt_connection_timeout }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('Keep Alive Interval')">
                            <span>{{ params.mqtt_keep_alive_interval }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('CleanSession')">
                            <span>{{ params.mqtt_clean_session }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.mqtt_automatic_reconnection')">
                            <span>{{ params.mqtt_auto_reconnect }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('MaxInflight')">
                            <span>{{ params.mqtt_max_inflight }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.data_storage_time')">
                            <span>{{ params.data_retention_time }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item :label="$t('integration.equipment_limited_quantity')">
                            <span> {{ params.equipment_limit_quantity }}</span>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
        </el-form>

        <!-- 命令详情 -->
        <!-- <CmdDialog :title="cmdTitle" :isShow.sync="cmdShow" v-bind="$attrs" :cmdObj="cmdObj" /> -->
    </div>
</template>

<script>
export default {
    props: {
        completeInfo: {
            type: Object
        }
    },

    computed: {
        params() {
            return this.completeInfo;
        }
    }
};
</script>

<style lang="scss" scoped></style>
